module.exports = __webpack_public_path__ + "static/img/组 2940.b1e27a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/组 2940.png
// module id = JxWK
// module chunks = 0